export default __webpack_public_path__ + "static/media/1967.399fa8da.png";